import { useFeatureValue } from '@growthbook/growthbook-react';
import { ArrowForward } from '@mui/icons-material';
import { Box, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';

import { newFeatureFilterCPD, newFeatureFilterCPE } from '@/assets';
import { Button, NewFeatureBanner } from '@/components';
import { Routes } from '@/constants';
import {
  selectUserCompliance,
  useAppSelector,
  useFetchUserUIStatesQuery,
  useUpdateUserUIStateMutation,
} from '@/store';

export const useIsTrackerNewFeaturesModalVisible = () => {
  const trackerUpdatesV1 = useFeatureValue('tracker-updates-v1', false);
  const { isTrackerNewFeaturesModalDismissed } = useFetchUserUIStatesQuery(
    undefined,
    {
      selectFromResult: result => ({
        ...result,
        isTrackerNewFeaturesModalDismissed: result.isSuccess
          ? !!result.data?.isTrackerNewFeaturesModalDismissed
          : true,
      }),
    },
  );
  return !isTrackerNewFeaturesModalDismissed && trackerUpdatesV1;
};

export const TrackerNewFeatureBanner = () => {
  const navigate = useNavigate();
  const compliance = useAppSelector(selectUserCompliance);
  const [setIsTrackerNewFeaturesModalDismissed] =
    useUpdateUserUIStateMutation();

  return (
    <NewFeatureBanner
      onClose={() =>
        setIsTrackerNewFeaturesModalDismissed({
          key: 'isTrackerNewFeaturesModalDismissed',
          value: true,
        })
      }>
      <Box
        sx={{
          height: '120px',
          width: '100%',
          position: 'relative',
          overflow: 'hidden',
          borderRadius: 2,
          px: 5,
          pt: 2,
          bgcolor: 'white',
          border: theme => `1px solid ${theme.palette.secondary.main}80`,
        }}>
        <Box
          sx={[
            styles.blur,
            {
              top: -73,
              left: -70,
              width: 130,
              height: 130,
              bgcolor: 'accent.main',
            },
          ]}
        />
        <Box
          sx={[
            styles.blur,
            {
              bottom: -75,
              right: -47,
              width: 130,
              height: 130,
              bgcolor: 'secondary.main',
            },
          ]}
        />
        <Box
          component="img"
          src={compliance === 'CPD' ? newFeatureFilterCPD : newFeatureFilterCPE}
          sx={{
            position: 'relative',
            width: '100%',
          }}
        />
      </Box>
      <Typography variant="body2SemiBold" sx={{ mt: 2 }}>
        See your totals at a glance.
      </Typography>
      <Typography variant="body3" sx={{ mt: 1.25 }}>
        Your certificate table now adds up your certificates and{' '}
        {compliance === 'CPD' ? 'CPD hours' : 'CPE credits'} as you filter.
        Filter by LumiQ or External to see exactly where your{' '}
        {compliance === 'CPD' ? 'hours' : 'credits'} came from.
      </Typography>
      <Button
        variant="plain"
        label="Go to Tracker"
        endIcon={<ArrowForward />}
        fullWidth={false}
        sx={{ mt: 1.25 }}
        onClick={() => {
          navigate(Routes.TRACKER);
          setIsTrackerNewFeaturesModalDismissed({
            key: 'isTrackerNewFeaturesModalDismissed',
            value: true,
          });
        }}
      />
    </NewFeatureBanner>
  );
};

const styles = {
  blur: {
    position: 'absolute',
    width: 130,
    height: 130,
    opacity: 0.2,
    filter: 'blur(37.5px)',
    borderRadius: '50%',
  },
};
